import { uid } from "@xbs/lib-state";
import { flattenToTree, isSameId, treeToFlatten } from "../helpers";
export function normalizeStructure(tasks) {
    return treeToFlatten(flattenToTree(tasks));
}
export function normalizeData(tasks, selected) {
    const date = new Date();
    return normalizeStructure(tasks).map((task) => {
        const id = task.id ?? uid().toString();
        delete task.selected;
        delete task.draggable;
        if (task.checked && !task["completion_date"]) {
            task.completion_date = date;
        }
        if (!task["creation_date"]) {
            task.creation_date = date;
        }
        if (selected.some(i => isSameId(i, id))) {
            task.selected = true;
        }
        return { ...task, id };
    });
}
export function normalizeTreeItem(task, children, taskShape) {
    if (task?.children?.length) {
        for (let index = 0; index < task.children.length; index++) {
            normalizeTreeItem(task.children[index], children, taskShape);
        }
    }
    task.counter = {
        type: taskShape?.counter?.type || "number",
        total: children[task.id].length,
        done: children[task.id].filter(t => t.checked === true).length,
    };
}
//# sourceMappingURL=normalize.js.map